export default (function ($) {

    var _instance = {}

    /**
     * Initialize the method
     *
     * @return false
     */
    _instance.init = function () {
        $(document).ready(function () {
            var menu_item = $('.menu.menu--dropdown .menu__item--has-children a.cta');

            if (menu_item.length > 0) {
                menu_item.on('click', function (e) {
                    if ($(this).hasClass('shown')){
                        $(this).parent('.menu__item--has-children').find('.sub-menu').slideUp();
                        $(this).removeClass('shown').find('wkngp-icon').removeClass('wkngp-icon--arrow-up').addClass('wkngp-icon--arrow-down');
                    } else {
                        $(this).parent('.menu__item--has-children').find('.sub-menu').slideDown();
                        $(this).addClass('shown').find('wkngp-icon').removeClass('wkngp-icon--arrow-down').addClass('wkngp-icon--arrow-up');
                    }
                })
            }

            var $dropdown = $(".dropdown.menu-item > a");
            $dropdown.on('click', function (e) {
                var $parent = $(this).closest(".dropdown.menu-item");
                $parent.find(".dropdown-menu").toggleClass("dropdown-menu--active");
            });

            $("html, body").on("click", function(e){
                var $target = $(e.target);
                var $closestDropdown = $target.closest(".dropdown");
                if($target.closest(".dropdown").length === 0) {
                    var $openDropdowns = $(".dropdown.menu-item .dropdown-menu");
                } else {
                    var $openDropdowns = $(".dropdown.menu-item .dropdown-menu").not($closestDropdown.find(".dropdown-menu"));
                }

                $openDropdowns.removeClass("dropdown-menu--active");
            });

        });
    };

    return _instance;

})(jQuery)